/**
 * @generated SignedSource<<f4cf6a8471a41e02f46b7f798b4b8306>>
 * @relayHash 2cdf89db87adee5dddc476f1a2e53596
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 747e3daf502679faa1ad94203ba6d12953c7dba1af225a480cf8c0196c25872b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getIssueTypePropsQuery$variables = {
  cloudId: string;
  jql: string;
};
export type getIssueTypePropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly issueTypes: {
        readonly aboveBaseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly baseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly belowBaseLevel: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string;
              readonly issueTypes: ReadonlyArray<{
                readonly avatar: {
                  readonly xsmall: string | null | undefined;
                } | null | undefined;
              }>;
              readonly jqlTerm: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getIssueTypePropsQuery = {
  response: getIssueTypePropsQuery$data;
  variables: getIssueTypePropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jql"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v7 = [
  {
    "concreteType": "JiraJqlIssueTypeFieldValueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraJqlIssueTypeFieldValue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v10 = [
  {
    "concreteType": "JiraJqlIssueTypeFieldValueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraJqlIssueTypeFieldValue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueTypes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getIssueTypePropsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlIssueTypes",
                  "kind": "LinkedField",
                  "name": "issueTypes",
                  "plural": false,
                  "selections": [
                    {
                      "args": (v3/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "aboveBaseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "aboveBaseLevel(first:2)"
                    },
                    {
                      "args": (v8/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "baseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "baseLevel(first:3)"
                    },
                    {
                      "args": (v9/*: any*/),
                      "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                      "kind": "LinkedField",
                      "name": "belowBaseLevel",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": "belowBaseLevel(first:5)"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getIssueTypePropsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlIssueTypes",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "args": (v3/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "aboveBaseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "aboveBaseLevel(first:2)"
                  },
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "baseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "baseLevel(first:3)"
                  },
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "belowBaseLevel",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "belowBaseLevel(first:5)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "747e3daf502679faa1ad94203ba6d12953c7dba1af225a480cf8c0196c25872b",
    "metadata": {},
    "name": "getIssueTypePropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "17bea9b8ff26d8a4659bd6ec446f6ccc";

export default node;
